import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import InputWithSection from 'jd-library/InputWithSection'
import styles from './unit-count.scss'
import { updateEditProductDetail } from "../../../actions/products"
import { SpecificDurationDropDown } from "../../../pages/add-edit-product/StaticData.js";


const UnitCount = (props) => {
    const [addPriceUomDD, setAddPriceUomDD] = useState(isNaN(props?.uomDetails?.customUnit) ? props?.uomDetails?.customUnit : "months" || 'months')
    const [uomCount, setUomCount] = useState(!isNaN(props?.customDuration) ? props?.customDuration : "1" || '')
    const count = useSelector(state => state.products?.editProduct?.unitcount);
    const priceData = useSelector(state => state.products?.pricecardData?.productData[props?.currentIndex]);
    const outDatedPriceData = useSelector(state => state.products?.outDatedPricecardData[props?.currentIndex]);
    const isMobile = useSelector(state => state.deviceData?.isMobile);
    const countStr = props.unit || count;
    const dispatch = useDispatch();
    const deviceData = useSelector(state => state.deviceData);
    const isJdSourceIOS = useSelector(state => state.session.isJdSourceIOS);
    const isIPhone = deviceData.isIphone || isJdSourceIOS;
    const isReadOnly = useSelector(state => state.session.isReadOnly)

    useEffect(() => {
        let softUom = ``;
        if (props.isFromAddPrice){
            if (props?.uomDetails?.uom?.val == 'stds' && ['Sess','Visit'].includes(props?.uomDetails?.customDuration)) {
                setAddPriceUomDD('months')
            }
            const newPriceData = props?.isFromOutDatedPrice ? outDatedPriceData?.uom?.val : priceData?.uom?.val
            softUom = `${uomCount} ${newPriceData == 'stds' ? addPriceUomDD : newPriceData}`
        }else {
            softUom = `${uomCount || countStr?.split(' ')[0] || 1} ${props.uomDetails.val}`
        }
        if(!props.isVariant) {
            updateProductDetails(softUom)
        }
    }, [props?.uomDetails?.val,addPriceUomDD,props?.uomDetails?.uom?.val == 'stds', props?.uomDetails?.uom?.val != props?.customDuration])


    useEffect(() => {
        if (countStr){
            let count = countStr?.split(' ')[0];
            if(count != uomCount) {
                setUomCount(count)
            }
        }
    },[countStr])

    const inputObj = {
        label: 'Title',
        key: 'title',
        holderClass: 'title-inp',
        input: {
            value: uomCount,
            type: isIPhone ? "tel" : "number",
            maxlength: 100,
            onChange: (e) => { handleChange(e, 'title') },
            onKeyDown: (e) => ["e", "E", "+", "-", "."].includes(e.key) && e.preventDefault()
        }
    }

    const handleChange = (e, type) => {
        let softUom = ''
        let softUomCount = e.target.value
        if (Number(e.target.value) > 0) {
            softUom = props.isFromAddPrice ? `${e.target.value} ${props.uomDetails.customDuration != 'stds' ? props.uomDetails.customDuration : addPriceUomDD}` :  `${e.target.value} ${props.uomDetails.val}`
        } else {
            softUom = props.isFromAddPrice ? `1 ${props.uomDetails.customDuration != 'stds' ? props.uomDetails.customDuration : addPriceUomDD }` : `1 ${props.uomDetails.val}`
        }
        setUomCount(softUomCount)
        if(props.isVariant) {
            props.updateUnit(softUom);
            return;
        }
        updateProductDetails(softUom)
    }

    const updateProductDetails = (softUom='',softUomCount) => {
         if (props.isFromAddPrice) {
            props.uomChange(softUomCount || softUom ? softUom.split(" ")[0] : '', props.currentIndex,softUom)
        } else {
            dispatch(updateEditProductDetail([
                {
                    key: "unitcount",
                    value: softUom,
                },
            ]))
        }
    }
    return (
        props.isFromAddPrice ?
            <div className={isMobile ? styles['unit-count-new-mobile'] :  styles['unit-count-new']}>
                <InputWithSection width='0.9-1.1' type="tel" textOnRight={false} withMovingLabel labelOnTop={true} label={`${props?.uomDetails?.uom?.val == 'stds' ? "Specific Duration" : `${props?.uomDetails?.uom?.singular} Count`}`} text={props?.uomDetails?.uom?.displayVal || props?.uomDetails?.displayVal}
                    input={inputObj.input}
                    dropdown={props.uomDetails.uom?.val == 'stds' ? {
                        optionList: SpecificDurationDropDown,
                        onChange: (e, value) => setAddPriceUomDD(e.key),
                        value: addPriceUomDD
                    } : null}
                />
            </div>
            :
        <div className={`${styles['unit-count']} ${isReadOnly ? 'read-only-mode' : '' } `}>
            <InputWithSection width='0.9-1.1' type="tel" withMovingLabel labelOnTop={true} 
            label={`${props.uomDetails.singular} Count`} 
            text={props.uomDetails.displayVal}
                input={inputObj.input}
            />
        </div>
    )
}



export default UnitCount;

